import React, { useState, useEffect } from "react";
import withAuth from "./../../common/helper/auth-component.js";
import { connect } from "react-redux";
import DashboardService from "../../../services/dashboard-service.js";
import LoaderOverlay from "./../../common/helper/loader.component.js";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Confirmation from "../../common/modals/confirmation.component.js";
import StatusBadge from "../../common/helper/transaction-status.component.js";
import { useLocation } from "react-router-dom";
import { MESSAGES } from "../../constants/constants.js";

const ViewTransaction = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [transaction, setTransaction] = useState({});
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const naviagate = useNavigate();
  const [role, setUserRole] = useState("");
  const userData = useSelector((state) => state.authReducer);
  const [modalShow, setModalShow] = React.useState(false);
  const [txnStatus, setTxnStatus] = React.useState();

  const getTransaction = () => {
    setLoading(true);
    DashboardService.getTransactionDetail(id)
      .then((response) => {
        const data = response.data.data;
        setTransaction(data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        try {
          const errorMessage = error.response.data;
          toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR);
        } catch (e) {
          toast.error(MESSAGES.SERVER_ERROR);
        }
      });
  };
  useEffect(() => {
    let userRole;
    if (userData && userData.user && userData.user.data) {
      userRole = userData.user.data.role.role_code;
      console.log(userRole);
      setUserRole(userRole);
    }
    getTransaction();
    document.body.style.backgroundColor = "#f0f6fa";
    return () => {
      document.body.style.backgroundColor = ""; // Reset body color when ComponentOne unmounts
    };
  }, []);

  const back = () => {
    const typeValue = queryParams.get("type");
    if (typeValue == "searchTransaction") {
      naviagate("/system-transactions?type=searchTransaction");
    } else if (typeValue == "ticketTransaction") {
      naviagate("/create-ticket?type=ticketTransaction");
    } else {
      naviagate(-1);
    }
  };

  const confirm = () => {
    naviagate(`/confirm-transaction/${id}/${transaction.order_code}`);
  };

  const raised = () => {
    naviagate(`/raised-transaction/${id}/${transaction.order_code}`);
  };
  const viewLifeCycle = () => {
    naviagate(`/view-lifecycle/${id}`);
  };
  const updateTransaction = (data) => {
    console.log(data);
    let statustoUpdate;
    let body = {};
    if (txnStatus == "approve") {
      statustoUpdate = "approved";
      body.action = "Y";
      body.updated_amount = data.formData.amount;
      body.updated_utr_id = data.formData.utr;
      body.remark = data.remark;
    } else {
      statustoUpdate = "rejected";
      body.action = "N";
    }
    setLoading(true);
    DashboardService.approveRejectTxn(body, id)
      .then((response) => {
        toast.success(`Transaction ${statustoUpdate} successfully.`);
        getTransaction();
        setModalShow(false);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        try {
          const errorMessage = error.response.data;
          toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR);
        } catch (e) {
          toast.error(MESSAGES.SERVER_ERROR);
        }
      });
  };
  const approve = () => {
    setTxnStatus("approve");
    setModalShow(true);
  };
  const reject = () => {
    setTxnStatus("reject");

    setModalShow(true);
  };

  return (
    <>
      <LoaderOverlay loading={loading} />
      <div className="container-fluid px-4" style={{ paddingBottom: "30px" }}>
        <h4 style={{ marginTop: 0, fontWeight: 700, fontSize: "16px" }}>
          Transaction Details
        </h4>
        <div
          className="row ghty"
          style={{
            backgroundColor: "white",
            height: "auto",
            paddingBottom: "20px",
          }}
        >
          <ul className="nav nav-tabs">
            <li className="nav-item tbbtrn">
              <a className="nav-link active_tab1" id="list_per_details">
                Transaction Information
              </a>
            </li>
          </ul>
          <div className="tab-content" style={{ marginTop: "0px", padding: 0 }}>
            <div className="tab-pane active" id="per_details">
              <div className="panel panel-default">
                <div className="panel-body" style={{ padding: "0px" }}>
                  <div
                    className="col-md-12"
                    style={{
                      border: "1px solid #f7f7f7",
                      borderRadius: "5px",
                      padding: "13px",
                    }}
                  >
                    <div
                      className="col-md-3"
                      style={{ padding: "0px", paddingRight: "15px" }}
                    >
                      <div
                        className="form-group frm"
                        style={{ textAlign: "left" }}
                      >
                        <label htmlFor="f_name">AGENT CODE</label>
                        <p>{transaction.agent_code}</p>
                      </div>
                    </div>
                    <div
                      className="col-md-3"
                      style={{ padding: "0px", paddingRight: "15px" }}
                    >
                      <div
                        className="form-group frm"
                        style={{ textAlign: "left" }}
                      >
                        <label htmlFor="f_name">SENDER NAME</label>
                        <p>{transaction.sender_name}</p>
                      </div>
                    </div>
                    <div
                      className="col-md-3"
                      style={{ padding: "0px", paddingRight: "15px" }}
                    >
                      <div
                        className="form-group frm"
                        style={{ textAlign: "left" }}
                      >
                        <label htmlFor="f_name">RECIEVER NAME</label>
                        <p>{transaction.receiver_name}</p>
                      </div>
                    </div>
                    <div
                      className="col-md-3"
                      style={{ padding: "0px", paddingRight: "15px" }}
                    >
                      <div
                        className="form-group frm"
                        style={{ textAlign: "left" }}
                      >
                        <label htmlFor="f_name">ORDER ID</label>
                        <p>{transaction.order_code}</p>
                      </div>
                    </div>
                    <div
                      className="col-md-3"
                      style={{ padding: "0px", paddingRight: "15px" }}
                    >
                      <div
                        className="form-group frm"
                        style={{ textAlign: "left" }}
                      >
                        <label htmlFor="f_name">MERCHANT ORDER CODE</label>
                        <p>{transaction.merchant_reference_code}</p>
                      </div>
                    </div>
                    <div
                      className="col-md-3"
                      style={{ padding: "0px", paddingRight: "15px" }}
                    >
                      <div
                        className="form-group frm"
                        style={{ textAlign: "left" }}
                      >
                        <label htmlFor="f_name">PAYMENT TYPE</label>
                        {/* <p style={{color: 'red'}}><i className="fa fa-money me-1" style={{color: 'red'}} /> Payin</p> */}

                        <p
                          style={{
                            color:
                              transaction &&
                              transaction.transaction_type?.toLowerCase() ===
                                "payin"
                                ? "green"
                                : "red",
                          }}
                        >
                          <i
                            className="fa fa-money me-1"
                            style={{
                              color:
                                transaction &&
                                transaction.transaction_type?.toLowerCase() ===
                                  "payin"
                                  ? "green"
                                  : "red",
                            }}
                          />{" "}
                          {transaction && transaction.transaction_type
                            ? transaction.transaction_type
                                .charAt(0)
                                .toUpperCase() +
                              transaction.transaction_type
                                .slice(1)
                                .toLowerCase()
                            : ""}
                        </p>
                      </div>
                    </div>
                    <div
                      className="col-md-3"
                      style={{ padding: "0px", paddingRight: "15px" }}
                    >
                      <div
                        className="form-group frm"
                        style={{ textAlign: "left" }}
                      >
                        <label htmlFor="f_name">TOTAL</label>
                        <p>₹{transaction.amount}</p>
                      </div>
                    </div>
                    <div
                      className="col-md-3"
                      style={{ padding: "0px", paddingRight: "15px" }}
                    >
                      <div
                        className="form-group frm"
                        style={{ textAlign: "left" }}
                      >
                        <label htmlFor="f_name">PAYMENT METHOD</label>
                        <p>
                          <i
                            className={`fa  me-1 ${
                              transaction.payment_method &&
                              transaction.payment_method?.toLowerCase() ===
                                "imps"
                                ? "fa-money"
                                : transaction.payment_method &&
                                  transaction.payment_method?.toLowerCase() ===
                                    "wallet"
                                ? "fa-credit-card"
                                : transaction.payment_method &&
                                  transaction.payment_method?.toLowerCase() ===
                                    "upi"
                                ? "fa-google-wallet"
                                : transaction.payment_method &&
                                  transaction.payment_method?.toLowerCase() ===
                                    "qr"
                                ? "fa-qrcode "
                                : ""
                            }`}
                          />
                          {transaction.payment_method || "-"}{" "}
                        </p>
                      </div>
                    </div>
                    <div
                      className="col-md-3"
                      style={{ padding: "0px", paddingRight: "15px" }}
                    >
                      <div
                        className="form-group frm"
                        style={{ textAlign: "left" }}
                      >
                        <label htmlFor="f_name">SUB PAYMENT METHOD</label>
                        <p>{transaction.payment_method_type || "-"}</p>
                      </div>
                    </div>
                    {transaction.vpa && (
                      <div
                        className="col-md-3"
                        style={{ padding: "0px", paddingRight: "15px" }}
                      >
                        <div
                          className="form-group frm"
                          style={{ textAlign: "left" }}
                        >
                          <label htmlFor="f_name">VPA</label>
                          <p style={{ wordWrap: "break-word" }}>
                            {transaction.vpa || "-"}
                          </p>
                        </div>
                      </div>
                    )}

                    {transaction.bank_account && (
                      <div
                        className="col-md-3"
                        style={{ padding: "0px", paddingRight: "15px" }}
                      >
                        <div
                          className="form-group frm"
                          style={{ textAlign: "left" }}
                        >
                          <label htmlFor="f_name">Bank Account</label>
                          <p>{transaction.bank_account || "-"}</p>
                        </div>
                      </div>
                    )}
                    {transaction.mobile && (
                      <div
                        className="col-md-3"
                        style={{ padding: "0px", paddingRight: "15px" }}
                      >
                        <div
                          className="form-group frm"
                          style={{ textAlign: "left" }}
                        >
                          <label htmlFor="f_name">Mobile</label>
                          <p>{transaction.mobile || "-"}</p>
                        </div>
                      </div>
                    )}

                    {transaction.ifsc && (
                      <div
                        className="col-md-3"
                        style={{ padding: "0px", paddingRight: "15px" }}
                      >
                        <div
                          className="form-group frm"
                          style={{ textAlign: "left" }}
                        >
                          <label htmlFor="f_name">IFSC</label>
                          <p>{transaction.ifsc || "-"}</p>
                        </div>
                      </div>
                    )}

                    <div
                      className="col-md-3"
                      style={{ padding: "0px", paddingRight: "15px" }}
                    >
                      <div
                        className="form-group frm"
                        style={{ textAlign: "left" }}
                      >
                        <label htmlFor="f_name">START DATE</label>
                        <p>{transaction.start_date}</p>
                      </div>
                    </div>
                    <div
                      className="col-md-3"
                      style={{ padding: "0px", paddingRight: "15px" }}
                    >
                      <div
                        className="form-group frm"
                        style={{ textAlign: "left" }}
                      >
                        <label htmlFor="f_name">STATUS</label>
                        <p>
                          <StatusBadge status={transaction.status} />
                        </p>
                      </div>
                    </div>
                    {/* <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                        <label htmlFor="f_name">CREATED BY</label>
                        <p>NA</p>
                      </div>
                    </div> */}
                    <div
                      className="col-md-3"
                      style={{ padding: "0px", paddingRight: "15px" }}
                    >
                      <div
                        className="form-group frm"
                        style={{ textAlign: "left" }}
                      >
                        <label htmlFor="f_name">UPDATED ON</label>
                        <p>{transaction.raised_date || "-"}</p>
                      </div>
                    </div>
                    <div
                      className="col-md-3"
                      style={{ padding: "0px", paddingRight: "15px" }}
                    >
                      <div
                        className="form-group frm"
                        style={{ textAlign: "left" }}
                      >
                        <label htmlFor="f_name">Description</label>
                        <p>{transaction.status_description || "-"}</p>
                      </div>
                    </div>
                    <div
                      className="col-md-3"
                      style={{ padding: "0px", paddingRight: "15px" }}
                    >
                      <div
                        className="form-group frm"
                        style={{ textAlign: "left" }}
                      >
                        <label htmlFor="f_name">UTR</label>
                        <p>{transaction.utr_id || "-"}</p>
                      </div>
                    </div>
                    <div
                      className="col-md-3"
                      style={{ padding: "0px", paddingRight: "15px" }}
                    >
                      <div
                        className="form-group frm"
                        style={{ textAlign: "left" }}
                      >
                        <label htmlFor="f_name">ScreenShots</label>
                        <div>
                          {transaction.screenshots &&
                          transaction.screenshots.length > 0 ? (
                            transaction.screenshots.map((screenshot, index) => (
                              <a
                                key={index}
                                href={screenshot}
                                download={`screenshot-${index + 1}.jpg`} // File name for downloaded image
                                style={{ marginRight: "10px" }} // Optional styling for spacing
                                target="_blank" // Open in a new window
                                rel="noopener noreferrer" // For security reasons
                              >
                                <img
                                  src={screenshot}
                                  alt={`Screenshot ${index + 1}`}
                                  style={{
                                    width: "100px",
                                    height: "auto",
                                    cursor: "pointer",
                                  }} // Adjust styling as needed
                                />
                              </a>
                            ))
                          ) : (
                            <p>-</p> // Placeholder if no screenshots are available
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <a style={{ width: "auto", padding: "0px" }} onClick={back}>
              <button className="btn backbt">Back</button>
            </a>
            {/* {
              transaction.status =='P' && (  */}
            <>
              {/* Agent case start */}
              {(transaction.transaction_type == "PAYIN" ||
                transaction.transaction_type == "PAYOUT") &&
                role == "AGENT" &&
                (transaction.status == "AA" ||
                  transaction.status == "RA" ||
                  transaction.status == "RM") && (
                  <a
                    style={{
                      width: "auto",
                      padding: "0px",
                      paddingLeft: "10px",
                    }}
                  >
                    <button
                      className="btn btn-bg-theme-Color cfrmbt"
                      onClick={confirm}
                    >
                      Confirm
                    </button>
                  </a>
                )}
              {(transaction.transaction_type == "PAYIN" ||
                transaction.transaction_type == "PAYOUT") &&
                role == "AGENT" &&
                (transaction.status == "AA" || transaction.status == "RM") && (
                  <a
                    style={{
                      width: "auto",
                      padding: "0px",
                      paddingLeft: "10px",
                    }}
                  >
                    <button
                      className="btn btn-bg-theme-Color raisbt"
                      onClick={raised}
                    >
                      Raised
                    </button>
                  </a>
                )}
              {/* Agent case ends */}

              {/* merchant case start */}

              {/* {(transaction.transaction_type == 'PAYIN' || transaction.transaction_type == 'PAYOUT') && role == 'MADMIN' && (transaction.status == 'AA' || transaction.status == 'RA' || transaction.status == 'RM') && (
               <a style={{width: 'auto', padding: '0px', paddingLeft: '10px'}} ><button className="btn btn-success cfrmbt"  onClick={confirm}>Confirm</button></a>
            )}
           {(transaction.transaction_type == 'PAYIN' || transaction.transaction_type == 'PAYOUT') && role == 'MADMIN' && (transaction.status == 'AA' || transaction.status == 'RA') && (
                  <a style={{width: 'auto', padding: '0px', paddingLeft: '10px'}} ><button className="btn btn-success raisbt"  onClick={raised}>Raised</button></a>   
            )} */}

              {/* merchant case ends */}

              {/* Admin approve reject starts here */}
              {(transaction.transaction_type == "PAYIN" ||
                transaction.transaction_type == "PAYOUT") &&
                role == "ADMIN" &&
                (transaction.status == "RA" || transaction.status == "RM") && (
                  <>
                    <a
                      style={{
                        width: "auto",
                        padding: "0px",
                        paddingLeft: "10px",
                      }}
                    >
                      <button
                        className="btn btn-bg-theme-Color cfrmbt btn-bg-theme-Color"
                        onClick={() => approve("approve")}
                      >
                        Approve
                      </button>
                    </a>
                    <a
                      style={{
                        width: "auto",
                        padding: "0px",
                        paddingLeft: "10px",
                      }}
                    >
                      <button
                        className="btn btn-bg-theme-Color raisbt"
                        onClick={() => reject("approve")}
                        style={{ background: "red" }}
                      >
                        Reject
                      </button>
                    </a>
                  </>
                )}
              {(transaction.transaction_type == "PAYIN" ||
                transaction.transaction_type == "PAYOUT") &&
                role == "ADMIN" &&
                (transaction.status == "E" ||
                  transaction.status == "F" ||
                  transaction.status == "AA") &&
                transaction.payment_method != null && (
                  <>
                    <a
                      style={{
                        width: "auto",
                        padding: "0px",
                        paddingLeft: "10px",
                      }}
                    >
                      <button
                        className="btn btn-bg-theme-Color cfrmbt btn-bg-theme-Color"
                        onClick={() => approve("approve")}
                      >
                        Approve
                      </button>
                    </a>
                  </>
                )}

              {/* Admin approve reject ends here */}

              {/* Merchant approve reject starts here */}
              {/* {(transaction.transaction_type == 'PAYIN') && role == 'MADMIN' && ( transaction.status == 'RM') && (
          <a style={{width: 'auto', padding: '0px', paddingLeft: '10px'}} ><button className="btn btn-success cfrmbt btn-bg-theme-Color"  onClick={() => approve('approve')}>Approve</button></a>
          )}
          {(transaction.transaction_type == 'PAYOUT') && role == 'MADMIN' && ( transaction.status == 'RM' || transaction.status == 'RA') && (
          <>
           <a style={{width: 'auto', padding: '0px', paddingLeft: '10px'}} ><button className="btn btn-success cfrmbt btn-bg-theme-Color"  onClick={() => approve('approve')}>Approve</button></a>
          
           </>
          )} */}
              {/* Merchant approve reject starts here */}

              <a
                style={{ width: "auto", padding: "0px", paddingLeft: "10px" }}
                onClick={viewLifeCycle}
              >
                <button className="btn btn-bg-theme-Color raisbt ">
                  Track Transaction
                </button>
              </a>
            </>

            {/* )}  */}
          </div>
        </div>
        <Confirmation
          show={modalShow}
          onHide={() => setModalShow(false)}
          onSave={(data) => updateTransaction(data)}
          status={txnStatus}
          modalId="updateTransaction"
        ></Confirmation>
      </div>
    </>
  );
};

function mapStateToProps(state) {
  const userData = state.authReducer.user;
  return { userData };
}
export default withAuth(connect(mapStateToProps)(ViewTransaction));
